/* EvenSkyn plug helper ("Which plug?", 27 Sep 2026).
   Adds a small "Which plug?" button beside the Power Adapter option on product pages. It opens a callout with the plug we
   think the visitor needs (IP country from /browsing_context_suggestions.json, then the store's market country, then the
   browser locale), a drawing of that plug, a one-tap select for the option, and a link to the full adapter guide.
   Loaded by snippets/evk-plug-help.liquid only on products that have a Power Adapter option. No dependencies. */
(function () {
  'use strict';
  if (window.__evkPlugHelp) return;
  window.__evkPlugHelp = true;

  var script = document.currentScript || document.querySelector('script[data-evk-ph]');
  var OPTION = ((script && script.getAttribute('data-option')) || 'Power Adapter').toLowerCase();
  var GUIDE = (script && script.getAttribute('data-guide')) || '';
  /* The snippet prints the guide link into the page HTML (hidden), so search engines see each product page linking to the
     guide. The callout shows that same link. While the guide page is still hidden, theme previews show it anyway for review. */
  var guideA = document.querySelector('a[data-evk-ph-guide]');
  if (guideA) GUIDE = guideA.getAttribute('href') || GUIDE;
  if (!GUIDE) {
    try { var role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role; if (role && role !== 'main') GUIDE = '/pages/power-adapter-guide'; } catch (e) {}
  }

  /* Country data, generated from the guide's data.js: iso,name,plug,alt,status (x direct, m mixed, p needs Type M adapter) */
  var RAW = [
    "US,United States,0,,x", "CA,Canada,0,,x", "MX,Mexico,0,,x", "BM,Bermuda,0,,x", "GL,Greenland,2,,x", "PM,Saint Pierre and Miquelon,2,,x",
    "AI,Anguilla,0,,x", "AG,Antigua and Barbuda,0,,x", "AW,Aruba,0,2,x", "BS,Bahamas,0,,x", "BB,Barbados,0,,x", "BZ,Belize,0,1,x",
    "BQ,Bonaire,0,2,m", "VG,British Virgin Islands,0,1,x", "KY,Cayman Islands,0,,x", "CR,Costa Rica,0,,x", "CU,Cuba,0,2,m", "CW,Curaçao,0,,x",
    "DM,Dominica,1,,x", "DO,Dominican Republic,0,2,x", "SV,El Salvador,0,,x", "GD,Grenada,1,,x", "GP,Guadeloupe,2,,x", "GT,Guatemala,0,,x",
    "HT,Haiti,0,,x", "HN,Honduras,0,,x", "JM,Jamaica,0,,x", "MQ,Martinique,2,,x", "MS,Montserrat,0,,x", "NI,Nicaragua,0,,x",
    "PA,Panama,0,,x", "PR,Puerto Rico,0,,x", "BL,Saint Barthélemy,2,,x", "KN,Saint Kitts and Nevis,0,1,m", "LC,Saint Lucia,1,,x", "MF,Saint Martin,2,,x",
    "VC,Saint Vincent and the Grenadines,1,0,m", "SX,Sint Maarten,0,,x", "TT,Trinidad and Tobago,0,,x", "TC,Turks and Caicos Islands,0,,x", "VI,U.S. Virgin Islands,0,,x", "AR,Argentina,3,2,m",
    "BO,Bolivia,0,2,m", "BR,Brazil,2,,x", "CL,Chile,2,,x", "CO,Colombia,0,,x", "EC,Ecuador,0,,x", "FK,Falkland Islands,1,,x",
    "GF,French Guiana,2,,x", "GY,Guyana,0,1,m", "PY,Paraguay,2,,x", "PE,Peru,0,2,m", "SR,Suriname,0,2,m", "UY,Uruguay,2,3,m",
    "VE,Venezuela,0,,x", "AL,Albania,2,,x", "AD,Andorra,2,,x", "AT,Austria,2,,x", "BY,Belarus,2,,x", "BE,Belgium,2,,x",
    "BA,Bosnia and Herzegovina,2,,x", "BG,Bulgaria,2,,x", "HR,Croatia,2,,x", "CY,Cyprus,1,,x", "CZ,Czechia,2,,x", "DK,Denmark,2,,x",
    "EE,Estonia,2,,x", "FO,Faroe Islands,2,,x", "FI,Finland,2,,x", "FR,France,2,,x", "DE,Germany,2,,x", "GI,Gibraltar,1,,x",
    "GR,Greece,2,,x", "GG,Guernsey,1,,x", "HU,Hungary,2,,x", "IS,Iceland,2,,x", "IE,Ireland,1,,x", "IM,Isle of Man,1,,x",
    "IT,Italy,2,,x", "JE,Jersey,1,,x", "XK,Kosovo,2,,x", "LV,Latvia,2,,x", "LI,Liechtenstein,2,,x", "LT,Lithuania,2,,x",
    "LU,Luxembourg,2,,x", "MT,Malta,1,,x", "MD,Moldova,2,,x", "MC,Monaco,2,,x", "ME,Montenegro,2,,x", "NL,Netherlands,2,,x",
    "MK,North Macedonia,2,,x", "NO,Norway,2,,x", "PL,Poland,2,,x", "PT,Portugal,2,,x", "RO,Romania,2,,x", "RU,Russia,2,,x",
    "SM,San Marino,2,,x", "RS,Serbia,2,,x", "SK,Slovakia,2,,x", "SI,Slovenia,2,,x", "ES,Spain,2,,x", "SE,Sweden,2,,x",
    "CH,Switzerland,2,,x", "TR,Turkey,2,,x", "UA,Ukraine,2,,x", "GB,United Kingdom,1,,x", "VA,Vatican City,2,,x", "BH,Bahrain,1,,x",
    "IR,Iran,2,,x", "IQ,Iraq,2,1,m", "IL,Israel,2,,x", "JO,Jordan,2,1,m", "KW,Kuwait,1,2,m", "LB,Lebanon,2,0,m",
    "OM,Oman,1,2,m", "PS,Palestine,2,,x", "QA,Qatar,1,,x", "SA,Saudi Arabia,1,0,m", "SY,Syria,2,,x", "AE,United Arab Emirates,1,2,x",
    "YE,Yemen,1,0,m", "DZ,Algeria,2,,x", "AO,Angola,2,,x", "BJ,Benin,2,,x", "BW,Botswana,1,,x", "BF,Burkina Faso,2,,x",
    "BI,Burundi,2,,x", "CV,Cabo Verde,2,,x", "CM,Cameroon,2,,x", "CF,Central African Republic,2,,x", "TD,Chad,2,,x", "KM,Comoros,2,,x",
    "CG,Congo (Brazzaville),2,,x", "CD,Congo (DRC),2,,x", "CI,Côte d'Ivoire,2,,x", "DJ,Djibouti,2,,x", "EG,Egypt,2,,x", "GQ,Equatorial Guinea,2,,x",
    "ER,Eritrea,2,,x", "SZ,Eswatini,2,,p", "ET,Ethiopia,2,,x", "GA,Gabon,2,,x", "GM,Gambia,1,,x", "GH,Ghana,1,,x",
    "GN,Guinea,2,,x", "GW,Guinea-Bissau,2,,x", "KE,Kenya,1,,x", "LS,Lesotho,2,,p", "LR,Liberia,0,2,m", "LY,Libya,2,,x",
    "MG,Madagascar,2,,x", "MW,Malawi,1,,x", "ML,Mali,2,,x", "MR,Mauritania,2,,x", "MU,Mauritius,1,2,m", "YT,Mayotte,2,,x",
    "MA,Morocco,2,,x", "MZ,Mozambique,2,,x", "NA,Namibia,2,,p", "NE,Niger,2,0,m", "NG,Nigeria,1,,x", "RE,Réunion,2,,x",
    "RW,Rwanda,2,,x", "SH,Saint Helena,1,,x", "ST,São Tomé and Príncipe,2,,x", "SN,Senegal,2,,x", "SC,Seychelles,1,,x", "SL,Sierra Leone,1,,x",
    "SO,Somalia,2,,x", "ZA,South Africa,2,,m", "SS,South Sudan,2,,x", "SD,Sudan,2,,x", "TZ,Tanzania,1,,x", "TG,Togo,2,,x",
    "TN,Tunisia,2,,x", "UG,Uganda,1,,x", "ZM,Zambia,1,2,m", "ZW,Zimbabwe,1,,x", "AF,Afghanistan,2,,x", "AM,Armenia,2,,x",
    "AZ,Azerbaijan,2,,x", "BD,Bangladesh,2,1,m", "BT,Bhutan,2,1,m", "BN,Brunei,1,,x", "KH,Cambodia,2,0,m", "CN,China,0,3,x",
    "GE,Georgia,2,,x", "HK,Hong Kong,1,,x", "IN,India,2,,m", "ID,Indonesia,2,,x", "JP,Japan,0,,x", "KZ,Kazakhstan,2,,x",
    "KG,Kyrgyzstan,2,,x", "LA,Laos,2,0,m", "MO,Macao,1,2,m", "MY,Malaysia,1,,x", "MV,Maldives,1,2,m", "MN,Mongolia,2,,x",
    "MM,Myanmar,2,1,m", "NP,Nepal,2,,m", "PK,Pakistan,2,1,m", "PH,Philippines,0,2,x", "SG,Singapore,1,,x", "KR,South Korea,2,,x",
    "LK,Sri Lanka,1,2,m", "TW,Taiwan,0,,x", "TJ,Tajikistan,2,,x", "TH,Thailand,0,2,x", "TL,Timor-Leste,2,3,m", "TM,Turkmenistan,2,,x",
    "UZ,Uzbekistan,2,,x", "VN,Vietnam,2,0,x", "AS,American Samoa,0,3,m", "AU,Australia,3,,x", "CX,Christmas Island,3,,x", "CK,Cook Islands,3,,x",
    "FJ,Fiji,3,,x", "PF,French Polynesia,2,0,m", "GU,Guam,0,,x", "KI,Kiribati,3,,x", "MH,Marshall Islands,0,,x", "FM,Micronesia,0,,x",
    "NR,Nauru,3,,x", "NC,New Caledonia,2,,x", "NZ,New Zealand,3,,x", "NU,Niue,3,,x", "NF,Norfolk Island,3,,x", "MP,Northern Mariana Islands,0,,x",
    "PW,Palau,0,,x", "PG,Papua New Guinea,3,,x", "PN,Pitcairn Islands,3,,x", "WS,Samoa,3,,x", "SB,Solomon Islands,3,1,m", "TK,Tokelau,3,,x",
    "TO,Tonga,3,,x", "TV,Tuvalu,3,,x", "VU,Vanuatu,3,1,m", "WF,Wallis and Futuna,2,,x"
  ].join(';');
  var THE_LIST = 'US,GB,AE,NL,PH,BS,GM,MV,DO,CF,KM,MH,SB,KY,VG,VI,TC,FK,FO,CK,PN,MP,CD,CG,IM';
  var CODES = ['US', 'UK', 'EU', 'AUS'];
  var BY = {};
  RAW.split(';').forEach(function (row) {
    var f = row.split(',');
    BY[f[0]] = { iso: f[0], name: f[1], plug: CODES[+f[2]], alt: f[3] === '' ? null : CODES[+f[3]], st: f[4] };
  });
  var THE = {};
  THE_LIST.split(',').forEach(function (k) { THE[k] = 1; });

  /* ---------- Drawings and icons ---------- */
  var FACE = '<rect x="26" y="26" width="148" height="148" rx="30" fill="#fff" stroke="#d9d2c6" stroke-width="3"/>';
  var M = ' fill="#b8bec5" stroke="#6b737b" stroke-width="2.5"';
  var PLUGS = {
    US: FACE + '<rect x="71" y="74" width="12" height="52" rx="2.5"' + M + '/><rect x="117" y="74" width="12" height="52" rx="2.5"' + M + '/>',
    UK: FACE + '<rect x="92" y="55" width="16" height="33" rx="2.5"' + M + '/><rect x="49" y="114" width="31" height="16" rx="2.5"' + M + '/><rect x="120" y="114" width="31" height="16" rx="2.5"' + M + '/>',
    EU: FACE + '<circle cx="66" cy="100" r="12"' + M + '/><circle cx="134" cy="100" r="12"' + M + '/>',
    AUS: FACE + '<rect x="68" y="70" width="12" height="50" rx="2.5"' + M + ' transform="rotate(30 74 95)"/><rect x="120" y="70" width="12" height="50" rx="2.5"' + M + ' transform="rotate(-30 126 95)"/>'
  };
  var PLUG_NAME = { US: 'Type A', UK: 'Type G', EU: 'Type C', AUS: 'Type I' };
  function plugSvg(code, size) {
    return '<svg viewBox="22 22 156 156" width="' + size + '" height="' + size + '" role="img" aria-label="' + code + ' plug, ' + PLUG_NAME[code] + '" focusable="false">' + PLUGS[code] + '</svg>';
  }
  var I = function (w, body, sw) {
    return '<svg width="' + w + '" height="' + w + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' + (sw || 2) + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + body + '</svg>';
  };
  var ICON_Q = I(16, '<circle cx="12" cy="12" r="9.25"/><path d="M9.7 9.4a2.45 2.45 0 0 1 4.75.85c0 1.65-2.45 2.1-2.45 3.6"/><path d="M12 17.1v.01" stroke-width="2.4"/>', 1.7);
  var ICON_PIN = I(13, '<path d="M12 21s-7-6.2-7-11.5a7 7 0 0 1 14 0C19 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/>');
  var ICON_CHECK = I(16, '<path d="M5 12.5l4.5 4.5L19 7.5"/>', 2.4);
  var ICON_ARROW = I(14, '<path d="M5 12h14M13 6l6 6-6 6"/>');
  var ICON_X = I(15, '<path d="M6 6l12 12M18 6 6 18"/>');

  var esc = function (s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  };

  /* ---------- Styles (injected once, only on pages that use the helper) ---------- */
  var CSS = [
    '.evk-ph{position:static;flex:none;display:inline-flex;align-items:center;margin:0;vertical-align:middle}',
    '.evk-ph-row--stack legend{flex-basis:100%}',
    '.evk-ph-row--stack legend~:not(.evk-ph){flex-basis:auto!important}',
    '.evk-ph__btn{position:relative;display:inline-flex;align-items:center;gap:6px;margin:0;padding:2px 0;border:0;border-radius:6px;background:none;box-shadow:none;font:inherit;font-size:13px;font-weight:500;line-height:1.2;letter-spacing:normal;text-transform:none;white-space:nowrap;color:inherit;opacity:.8;cursor:pointer;-webkit-tap-highlight-color:transparent;transition:opacity .15s}',
    '.evk-ph__btn::after{content:"";position:absolute;inset:-12px -8px}',
    '.evk-ph__btn svg{display:block;flex:none}',
    '.evk-ph__lbl{font-style:normal;text-decoration:underline;text-decoration-thickness:1px;text-underline-offset:3px}',
    '.evk-ph__btn[aria-expanded=true]{opacity:1}',
    '@media (hover:hover){.evk-ph__btn:hover{opacity:1}}',
    '.evk-ph__btn:focus-visible{outline:2px solid #790200;outline-offset:4px}',
    '.evk-ph__pop{position:absolute;z-index:50;top:0;left:0;width:344px;max-width:calc(100vw - 24px);margin:0;padding:16px 16px 14px;border-radius:18px;background:#fff;color:#1f1a17;text-align:left;font-size:14px;font-weight:400;line-height:1.45;letter-spacing:normal;text-transform:none;box-shadow:0 26px 60px -24px rgba(43,6,6,.45),0 0 0 1px rgba(43,20,16,.08);animation:evk-ph-in .18s cubic-bezier(.2,.7,.2,1)}',
    '.evk-ph__pop[hidden]{display:none}',
    '.evk-ph__pop,.evk-ph__pop *{box-sizing:border-box}',
    '.evk-ph__pop p{margin:0;padding:0;font-size:inherit;line-height:inherit;color:inherit}',
    '.evk-ph__pop:focus,.evk-ph__pop:focus-visible{outline:none}',
    '.evk-ph__arrow{position:absolute;top:-6px;left:24px;width:12px;height:12px;background:#fff;transform:rotate(45deg);border-radius:3px 0 0 0;box-shadow:-1px -1px 0 rgba(43,20,16,.08)}',
    '.evk-ph__x{position:absolute;top:8px;right:8px;display:grid;place-items:center;width:32px;height:32px;margin:0;padding:0;border:0;border-radius:50%;background:none;box-shadow:none;color:#8b8079;cursor:pointer;-webkit-tap-highlight-color:transparent}',
    '.evk-ph__x svg{display:block}',
    '@media (hover:hover){.evk-ph__x:hover{background:#f6f0ec;color:#1f1a17}}',
    '.evk-ph__eyebrow{display:flex!important;align-items:center;gap:6px;min-height:20px;padding-right:34px!important;font-size:11px!important;font-weight:600;line-height:1.3!important;letter-spacing:.12em!important;text-transform:uppercase;color:#790200!important}',
    '.evk-ph__eyebrow svg{display:block;flex:none}',
    '.evk-ph__main{display:grid;grid-template-columns:56px minmax(0,1fr);gap:12px;align-items:center;padding-top:12px}',
    '.evk-ph__thumb{display:grid;place-items:center;width:56px;height:56px;border-radius:15px;background:#f6f0ec}',
    '.evk-ph__thumb svg,.evk-ph__mini svg{display:block}',
    '.evk-ph__title{font-size:15px!important;font-weight:600;line-height:1.3!important;color:#1f1a17!important;text-wrap:balance}',
    '.evk-ph__title--solo{padding-right:34px!important}',
    '.evk-ph__line{padding-top:3px!important;font-size:13.5px!important;line-height:1.45!important;color:#5b504a!important;text-wrap:pretty}',
    '.evk-ph__line b{font-weight:600;color:#1f1a17}',
    '.evk-ph__acts{display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:10px 14px;padding-top:14px}',
    '.evk-ph__sel{display:inline-flex;align-items:center;justify-content:center;gap:7px;min-height:42px;margin:0;padding:0 20px;border:0;border-radius:999px;background:#790200;box-shadow:none;color:#fff;font:inherit;font-size:14px;font-weight:500;line-height:1.1;letter-spacing:normal;text-transform:none;cursor:pointer;-webkit-tap-highlight-color:transparent;transition:background-color .15s,transform .12s}',
    '@media (hover:hover){.evk-ph__sel:hover{background:#350302}}',
    '.evk-ph__sel:active{transform:scale(.97)}',
    '.evk-ph__sel:focus-visible{outline:2px solid #790200;outline-offset:3px}',
    '.evk-ph__sel.is-done,.evk-ph__sel:disabled{background:#2f6b45;cursor:default;transform:none}',
    '.evk-ph__sel svg,.evk-ph__ok svg{display:block;flex:none}',
    '.evk-ph__ok{display:inline-flex;align-items:center;gap:7px;min-height:42px;font-size:14px;font-weight:500;color:#2f6b45}',
    '.evk-ph__foot{display:grid;gap:8px;margin-top:14px;padding-top:10px;border-top:1px solid rgba(43,20,16,.08)}',
    '.evk-ph__alt{position:relative;display:flex;align-items:center;justify-content:space-between;gap:10px;margin:0 -8px;padding:8px;border-radius:10px;color:#790200;transition:background-color .15s}',
    '@media (hover:hover){.evk-ph__alt:hover{background:#f6f0ec}}',
    '.evk-ph__alt:has(.evk-ph__alt-a:focus-visible){box-shadow:0 0 0 2px #790200}',
    '.evk-ph__alt svg{display:block;flex:none}',
    '.evk-ph__alt-t{display:grid;gap:1px;min-width:0}',
    '.evk-ph__alt-q{font-size:12.5px;line-height:1.35;color:#8b8079}',
    '.evk-ph__alt-a{font-size:14px;font-weight:600;line-height:1.35;color:#790200!important;text-decoration:none!important;outline:none}',
    '.evk-ph__alt-a::before{content:"";position:absolute;inset:0;border-radius:10px}',
    '.evk-ph__note{font-size:12px!important;line-height:1.45!important;color:#8b8079!important}',
    '.evk-ph__rows{display:grid;gap:8px;padding-top:12px}',
    '.evk-ph__r{display:grid;grid-template-columns:36px minmax(0,1fr);gap:10px;align-items:center;font-size:13px;line-height:1.35;color:#5b504a}',
    '.evk-ph__r b{margin-right:3px;font-weight:600;color:#1f1a17}',
    '.evk-ph__mini{display:grid;place-items:center;width:36px;height:36px;border-radius:10px;background:#f6f0ec}',
    '.evk-ph__skel{display:grid;gap:8px;padding-top:14px}',
    '.evk-ph__skel span{display:block;height:12px;border-radius:6px;background:linear-gradient(90deg,#f3ede9,#ebe3de,#f3ede9);background-size:200% 100%;animation:evk-ph-sh 1.1s linear infinite}',
    '.evk-ph__skel span+span{width:62%}',
    '@keyframes evk-ph-in{from{opacity:0;transform:translateY(-4px)}to{opacity:1;transform:none}}',
    '@keyframes evk-ph-sh{from{background-position:200% 0}to{background-position:0 0}}',
    '.evk-ph--compact .evk-ph__btn{gap:0;opacity:.85}',
    '.evk-ph--compact .evk-ph__btn svg{width:17px;height:17px}',
    '.evk-ph--compact .evk-ph__lbl{position:absolute!important;width:1px;height:1px;margin:-1px;padding:0;border:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}',
    '@media (prefers-reduced-motion:reduce){.evk-ph__pop,.evk-ph__skel span{animation:none}.evk-ph__sel,.evk-ph__btn{transition:none}}'
  ].join('');
  var styled = false;
  function addStyles() {
    if (styled) return;
    styled = true;
    var st = document.createElement('style');
    st.setAttribute('data-evk-ph', '');
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  /* ---------- Where the visitor is ---------- */
  var KEY = 'evk-plug-cc';
  var geo = null, geoDone = false, geoStarted = false, waiters = [];
  try {
    var cached = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    if (cached && BY[cached.iso]) { geo = cached; geoDone = true; }
  } catch (e) {}

  function fallbackGeo() {
    try {
      var s = window.Shopify && window.Shopify.country ? String(window.Shopify.country).toUpperCase() : '';
      if (BY[s]) return { iso: s, src: 'store' };
    } catch (e) {}
    try {
      var m = ((navigator.languages && navigator.languages[0]) || navigator.language || '').match(/[-_]([A-Za-z]{2})(?![A-Za-z])/);
      if (m && BY[m[1].toUpperCase()]) return { iso: m[1].toUpperCase(), src: 'locale' };
    } catch (e) {}
    return null;
  }
  function finishGeo(g) {
    if (geoDone) return;
    geoDone = true;
    geo = g;
    if (g && g.src === 'ip') { try { sessionStorage.setItem(KEY, JSON.stringify(g)); } catch (e) {} }
    var w = waiters;
    waiters = [];
    w.forEach(function (fn) { fn(); });
  }
  function startGeo() {
    if (geoStarted || geoDone) return;
    geoStarted = true;
    var timer = setTimeout(function () { finishGeo(fallbackGeo()); }, 2500);
    try {
      if (!window.fetch) throw 0;
      fetch('/browsing_context_suggestions.json', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          clearTimeout(timer);
          var iso = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
          iso = iso ? String(iso).toUpperCase() : '';
          finishGeo(BY[iso] ? { iso: iso, src: 'ip' } : fallbackGeo());
        })
        .catch(function () { clearTimeout(timer); finishGeo(fallbackGeo()); });
    } catch (e) { clearTimeout(timer); finishGeo(fallbackGeo()); }
  }
  function whenGeo(fn) { if (geoDone) fn(); else { waiters.push(fn); startGeo(); } }

  function track(action, plug) {
    try {
      var A = window.Shopify && window.Shopify.analytics;
      if (A && A.publish) A.publish('evk_plug_help', { action: action, country: geo ? geo.iso : '', source: geo ? geo.src : '', plug: plug || '', path: location.pathname });
    } catch (e) {}
  }

  /* ---------- Reading and driving the theme's option picker ---------- */
  var norm = function (t) { return String(t || '').trim().split(' ').join('').toUpperCase(); };
  var codeOf = function (text) { var t = norm(text); return t.split('/')[0]; };
  function labelEl(fs, input) {
    var l = null;
    if (input.id) { try { l = fs.querySelector('label[for="' + (window.CSS && window.CSS.escape ? window.CSS.escape(input.id) : input.id) + '"]'); } catch (e) {} }
    return l || input.closest('label');
  }
  function choices(fs) {
    var out = [];
    fs.querySelectorAll('input[type="radio"]').forEach(function (inp) {
      var l = labelEl(fs, inp);
      var text = (l ? l.textContent : inp.value).trim();
      out.push({ el: inp, label: l, text: text, code: codeOf(text), checked: inp.checked });
    });
    var sel = fs.querySelector('select');
    if (sel) {
      Array.prototype.forEach.call(sel.options, function (o) {
        var text = o.textContent.trim();
        out.push({ el: o, select: sel, text: text, code: codeOf(text), checked: o.selected });
      });
    }
    return out;
  }
  function pick(fs, code) { var c = choices(fs); for (var i = 0; i < c.length; i++) if (c[i].code === code) return c[i]; return null; }
  function current(fs) { var c = choices(fs); for (var i = 0; i < c.length; i++) if (c[i].checked) return c[i]; return null; }
  function choose(ch) {
    if (ch.select) {
      ch.select.value = ch.el.value;
      ch.select.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      (ch.label || ch.el).click();
    }
  }

  /* ---------- One helper per Power Adapter option on the page ---------- */
  var uid = 0, openH = null, helpers = [];

  function legendText(l) {
    var t = (l.textContent || '').trim();
    while (t.slice(-1) === ':') t = t.slice(0, -1).trim();
    return t.toLowerCase();
  }
  function findFieldsets() {
    var out = [];
    document.querySelectorAll('fieldset legend').forEach(function (l) {
      if (legendText(l) === OPTION) { var fs = l.closest('fieldset'); if (fs && out.indexOf(fs) < 0) out.push(fs); }
    });
    return out;
  }

  /* Follow the theme's label layout. On phones it puts the chosen value on its own line under "POWER ADAPTER:", so the
     icon joins the value on that line. Narrow columns (Power Adapter and Color side by side) show the icon without its label. */
  function fit(h) {
    var val = h.legend.nextElementSibling;
    if (val === h.wrap) val = null;
    h.row.classList.remove('evk-ph-row--stack');
    if (val && getComputedStyle(val).flexBasis === '100%') h.row.classList.add('evk-ph-row--stack');
    var w = h.row.getBoundingClientRect().width;
    if (w > 0) h.wrap.classList.toggle('evk-ph--compact', w < 300);
  }

  function mount(fs) {
    var legend = null;
    fs.querySelectorAll('legend').forEach(function (l) { if (!legend && legendText(l) === OPTION) legend = l; });
    if (!legend) return;
    var row = fs.querySelector('.variant-picker__option-info') || legend.parentElement;
    addStyles();
    row.classList.add('evk-ph-row');
    var id = 'evk-ph-' + (++uid);
    var wrap = document.createElement('div');
    wrap.className = 'evk-ph';
    wrap.innerHTML = '<button type="button" class="evk-ph__btn" aria-expanded="false" aria-haspopup="dialog" aria-controls="' + id + '" title="Which plug do I need?">' +
      ICON_Q + '<i class="evk-ph__lbl">Which plug?</i></button>';
    /* Straight after the chosen value ("POWER ADAPTER: US ?"), so it reads as part of this option, never the one beside it */
    var val = legend.nextElementSibling;
    legend.parentElement.insertBefore(wrap, val ? val.nextSibling : legend.nextSibling);
    /* The callout lives on <body> so a narrow column or an overflow rule in the theme can never squeeze or clip it */
    var pop = document.createElement('div');
    pop.className = 'evk-ph__pop';
    pop.id = id;
    pop.setAttribute('role', 'dialog');
    pop.setAttribute('aria-labelledby', id + '-t');
    pop.tabIndex = -1;
    pop.hidden = true;
    document.body.appendChild(pop);
    var h = { fs: fs, row: row, legend: legend, id: id, wrap: wrap, btn: wrap.firstChild, pop: pop };
    helpers.push(h);
    fit(h);

    var intent = function () { startGeo(); };
    h.btn.addEventListener('pointerenter', intent);
    h.btn.addEventListener('touchstart', intent, { passive: true });
    h.btn.addEventListener('focus', intent);
    h.btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (openH === h) close(h, true); else open(h);
    });
    h.pop.addEventListener('click', function (e) {
      e.stopPropagation();
      var t = e.target;
      if (t.closest('[data-x]')) { close(h, true); return; }
      var s = t.closest('[data-sel]');
      if (s) { select(h, s.getAttribute('data-sel'), s); return; }
      if (t.closest('.evk-ph__alt-a')) track('guide', geo && BY[geo.iso] ? BY[geo.iso].plug : '');
    });
  }

  function lineFor(c, fs) {
    var labOf = function (code) { var ch = pick(fs, code); return esc(ch ? ch.text : code); };
    var lab = '<b>' + labOf(c.plug) + '</b>';
    if (c.st === 'p') return 'Pick ' + lab + ' and add a local Type M plug adapter. None of our plugs fit Type M sockets directly.';
    if (c.st === 'm') return 'Pick ' + lab + '. It fits most sockets there' + (c.alt ? ', and ' + labOf(c.alt) + ' fits some too.' : '.');
    return 'Pick ' + lab + '. It fits the wall sockets there' + (c.alt ? ', and ' + labOf(c.alt) + ' works too.' : '.');
  }

  function actionFor(fs, code) {
    var ch = pick(fs, code);
    if (!ch) return '';
    var cur = current(fs);
    if (cur && cur.code === code) return '<span class="evk-ph__ok">' + ICON_CHECK + esc(ch.text) + ' is selected</span>';
    return '<button type="button" class="evk-ph__sel" data-sel="' + code + '">Select ' + esc(ch.text) + '</button>';
  }

  /* Below a divider: a way out for anyone shopping for another country, or who wants the full guide */
  function foot(q) {
    var alt = GUIDE ? '<div class="evk-ph__alt"><span class="evk-ph__alt-t"><span class="evk-ph__alt-q">' + esc(q) + '</span><span data-alt-a></span></span>' + ICON_ARROW + '</div>' : '';
    return '<div class="evk-ph__foot">' + alt + '<p class="evk-ph__note">Every EvenSkyn adapter takes 100 to 240 V, so only the plug shape changes.</p></div>';
  }
  function fillAlt(h) {
    var slot = h.pop.querySelector('[data-alt-a]');
    if (!slot) return;
    if (!guideA) { guideA = document.createElement('a'); guideA.href = GUIDE; guideA.textContent = 'Find your plug by country'; }
    guideA.className = 'evk-ph__alt-a';
    slot.parentNode.replaceChild(guideA, slot);
  }

  var GENERIC = [
    ['US', 'United States, Canada, Mexico, Japan'],
    ['UK', 'UK, Ireland, UAE, Singapore'],
    ['EU', 'Europe, India, Brazil and most of the world'],
    ['AUS', 'Australia, New Zealand, Argentina']
  ];

  function render(h) {
    var head = '<span class="evk-ph__arrow" aria-hidden="true"></span><button type="button" class="evk-ph__x" data-x aria-label="Close">' + ICON_X + '</button>';
    if (!geoDone) {
      h.pop.innerHTML = head + '<p class="evk-ph__eyebrow evk-ph__wait" id="' + h.id + '-t">' + ICON_PIN + 'Finding your plug</p><div class="evk-ph__skel" aria-hidden="true"><span></span><span></span></div>';
      return;
    }
    var c = geo && BY[geo.iso];
    if (c) {
      var act = actionFor(h.fs, c.plug);
      h.pop.innerHTML = head +
        '<p class="evk-ph__eyebrow">' + ICON_PIN + (geo.src === 'locale' ? 'Based on your browser settings' : 'Based on your location') + '</p>' +
        '<div class="evk-ph__main"><span class="evk-ph__thumb">' + plugSvg(c.plug, 46) + '</span><div class="evk-ph__txt">' +
        '<p class="evk-ph__title" id="' + h.id + '-t">You’re in ' + (THE[c.iso] ? 'the ' : '') + esc(c.name) + '</p>' +
        '<p class="evk-ph__line">' + lineFor(c, h.fs) + '</p></div></div>' +
        (act ? '<div class="evk-ph__acts">' + act + '</div>' : '') + foot('Not in ' + (THE[c.iso] ? 'the ' : '') + c.name + '?');
    } else {
      h.pop.innerHTML = head +
        '<p class="evk-ph__title evk-ph__title--solo" id="' + h.id + '-t">Which plug do I need?</p>' +
        '<p class="evk-ph__line">Pick the plug for the country where you’ll use it.</p>' +
        '<div class="evk-ph__rows">' + GENERIC.map(function (g) {
          var ch = pick(h.fs, g[0]);
          return '<div class="evk-ph__r"><span class="evk-ph__mini">' + plugSvg(g[0], 30) + '</span><span><b>' + esc(ch ? ch.text : g[0]) + '</b> ' + g[1] + '</span></div>';
        }).join('') + '</div>' +
        foot('Not sure?');
    }
    fillAlt(h);
  }

  /* A zero-size marker on <body>: where it sits on screen is the origin the callout's left and top are measured from */
  var probe = null;
  function origin() {
    if (!probe || !document.contains(probe)) {
      probe = document.createElement('div');
      probe.setAttribute('aria-hidden', 'true');
      probe.style.cssText = 'position:absolute;left:0;top:0;width:0;height:0;margin:0;padding:0;border:0;visibility:hidden;pointer-events:none';
      document.body.appendChild(probe);
    }
    return probe.getBoundingClientRect();
  }

  /* The lowest line the callout should reach: above a cookie banner, sticky add to cart bar or chat button pinned to the bottom.
     Bars can stack (a cookie banner under a smaller bar), so after each one found it looks again just above it. */
  function pinnedTop(x, y) {
    for (var n = document.elementFromPoint(x, y); n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
      var pos = getComputedStyle(n).position;
      if (pos === 'fixed' || pos === 'sticky') return n.getBoundingClientRect().top;
    }
    return -1;
  }
  function safeBottom() {
    var vh = window.innerHeight, vw = document.documentElement.clientWidth || window.innerWidth, b = vh - 32;
    [0.2, 0.5, 0.8].forEach(function (fx) {
      var y = vh - 6;
      for (var i = 0; i < 4; i++) {
        var t = pinnedTop(vw * fx, y);
        if (t <= vh * 0.3 || t >= y) break;
        b = Math.min(b, t - 12);
        y = t - 6;
      }
    });
    return b;
  }

  function place(h, still) {
    if (h.pop.hidden) return;
    var vw = document.documentElement.clientWidth || window.innerWidth;
    var gutter = 12;
    var host = h.fs.closest('variant-picker, .variant-picker, .product-info__variant-picker, .product-info') || h.fs;
    var hr = host.getBoundingClientRect();
    var rr = h.row.getBoundingClientRect();
    var icon = h.btn.querySelector('svg');
    var ir = (icon || h.btn).getBoundingClientRect();
    var cx = ir.left + ir.width / 2;
    var left, width;
    if (vw < 700) {
      left = Math.max(gutter, hr.left);
      width = Math.min(hr.right, vw - gutter) - left;
      if (width < 300) { left = gutter; width = vw - gutter * 2; }
    } else {
      width = Math.min(344, vw - gutter * 2);
      var minL = Math.max(gutter, Math.min(hr.left, cx - 40));
      var maxL = Math.min(vw - gutter, Math.max(hr.right, cx + 40)) - width;
      left = Math.max(minL, Math.min(cx - width + 44, maxL));
    }
    /* Position against the probe, so a positioned or offset <body> cannot shift the callout */
    var o = origin();
    h.pop.style.width = Math.round(width) + 'px';
    h.pop.style.left = Math.round(left - o.left) + 'px';
    h.pop.style.top = Math.round(rr.bottom + 12 - o.top) + 'px';
    var arrow = h.pop.querySelector('.evk-ph__arrow');
    if (arrow) arrow.style.left = Math.round(Math.max(14, Math.min(width - 26, cx - left - 6))) + 'px';
    if (still) return;
    /* Scroll just enough to show the whole callout above any bar pinned to the bottom, without pushing its top off screen */
    var top = rr.bottom + 12, bottom = top + h.pop.offsetHeight;
    var d = Math.min(bottom - safeBottom(), top - 72);
    if (d > 0) {
      try { window.scrollBy({ top: d, behavior: 'smooth' }); } catch (e) { window.scrollBy(0, d); }
    }
  }

  function open(h) {
    if (openH && openH !== h) close(openH, false);
    openH = h;
    render(h);
    h.pop.hidden = false;
    h.btn.setAttribute('aria-expanded', 'true');
    place(h);
    try { h.pop.focus({ preventScroll: true }); } catch (e) { h.pop.focus(); }
    if (!geoDone) {
      whenGeo(function () { if (openH === h) { render(h); place(h); track('open', geo && BY[geo.iso] ? BY[geo.iso].plug : ''); } });
    } else {
      track('open', geo && BY[geo.iso] ? BY[geo.iso].plug : '');
    }
  }

  function close(h, refocus) {
    if (!h || h.pop.hidden) { if (openH === h) openH = null; return; }
    h.pop.hidden = true;
    h.btn.setAttribute('aria-expanded', 'false');
    if (openH === h) openH = null;
    if (refocus && document.contains(h.btn)) { try { h.btn.focus({ preventScroll: true }); } catch (e) {} }
  }

  function liveFieldset(h) {
    if (document.contains(h.fs)) return h.fs;
    var all = findFieldsets();
    return all.length ? all[0] : null;
  }

  function select(h, code, buttonEl) {
    var ch = pick(h.fs, code);
    if (!ch) return;
    choose(ch);
    track('select', code);
    if (buttonEl && document.contains(buttonEl)) {
      buttonEl.disabled = true;
      buttonEl.classList.add('is-done');
      buttonEl.innerHTML = ICON_CHECK + esc(ch.text) + ' selected';
    }
    setTimeout(function () {
      var fs = liveFieldset(h);
      var cur = fs ? current(fs) : null;
      if (cur && cur.code === code) {
        close(h, true);
        /* If the theme re-rendered the picker, hand focus to the new button so keyboard users keep their place. */
        if (!document.contains(h.btn) && fs) { var nb = fs.querySelector('.evk-ph__btn'); if (nb) { try { nb.focus({ preventScroll: true }); } catch (e) {} } }
        return;
      }
      /* The theme did not take the change: open its own menu so the visitor can finish by hand. */
      close(h, false);
      var menu = fs && fs.querySelector('button.select, select');
      if (menu) { if (menu.tagName === 'SELECT') menu.focus(); else menu.click(); }
    }, 850);
  }

  /* Close on outside tap or Escape. Scroll and resize re-anchor it (the info column can be sticky, and phone URL bars resize the window). */
  document.addEventListener('pointerdown', function (e) {
    if (!openH) return;
    if (openH.pop.contains(e.target) || openH.btn.contains(e.target)) return;
    close(openH, false);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openH) { e.preventDefault(); close(openH, true); }
  });
  window.addEventListener('resize', function () { helpers.forEach(fit); if (openH) place(openH, true); });
  window.addEventListener('scroll', function () { if (openH) place(openH, true); }, { passive: true });

  /* Mount now, and again whenever the theme re-renders the picker after a variant change */
  function scan() {
    helpers = helpers.filter(function (h) {
      if (document.contains(h.btn)) return true;
      if (openH === h) openH = null;
      if (h.pop.parentNode) h.pop.parentNode.removeChild(h.pop);
      return false;
    });
    findFieldsets().forEach(function (fs) { if (!fs.querySelector('.evk-ph')) mount(fs); });
  }
  scan();
  if (helpers.length) {
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1800); };
    idle(startGeo, { timeout: 4000 });
    /* A link ending in #which-plug opens the helper straight away (handy for support replies and QA). */
    if (location.hash === '#which-plug') {
      var h0 = helpers[0];
      try { h0.row.scrollIntoView({ block: 'center' }); } catch (e) {}
      whenGeo(function () { if (document.contains(h0.btn)) open(h0); });
    }
  }
  /* setTimeout rather than requestAnimationFrame: frames pause in background tabs, timers do not */
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; scan(); }, 60);
  }).observe(document.body, { childList: true, subtree: true });
})();